const prefix = "GENERAL_SETTINGS"

export const types = {
  MOUNT_TAB: `${prefix}/MOUNT_TAB`,
  UNMOUNT_TAB: `${prefix}/UNMOUNT_TAB`,
  SET_FORM_STATE: `${prefix}/SET_FORM_STATE`,
  FETCH_SETTINGS_REQUESTED: `${prefix}/FETCH_SETTINGS_REQUESTED`,
  FETCH_SETTINGS_SUCCEED: `${prefix}/FETCH_SETTINGS_SUCCEED`,
  FETCH_SETTINGS_FAILED: `${prefix}/FETCH_SETTINGS_FAILED`,
  SAVE_SETTINGS_REQUESTED: `${prefix}/SAVE_SETTINGS_REQUESTED`,
  SAVE_SETTINGS_SUCCEED: `${prefix}/SAVE_SETTINGS_SUCCEED`,
  SAVE_SETTINGS_FAILED: `${prefix}/SAVE_SETTINGS_FAILED`,
  SAVE_SETTINGS_CANCELED: `${prefix}/SAVE_SETTINGS_CANCELED`,
}

export const actions = {
  mountTab: () => ({ type: types.MOUNT_TAB }),
  unmountTab: () => ({ type: types.UNMOUNT_TAB }),

  setFormState: (formState) => ({
    type: types.SET_FORM_STATE,
    payload: { formState },
  }),

  fetchSettingsRequested: () => ({ type: types.FETCH_SETTINGS_REQUESTED }),

  fetchSettingsSucceed: (settings) => ({
    type: types.FETCH_SETTINGS_SUCCEED,
    payload: { settings },
  }),

  fetchSettingsFailed: (error) => ({
    type: types.FETCH_SETTINGS_FAILED,
    payload: { error },
  }),

  saveSettingsRequested: () => ({ type: types.SAVE_SETTINGS_REQUESTED }),
  saveSettingsSucceed: () => ({ type: types.SAVE_SETTINGS_SUCCEED }),

  saveSettingsFailed: () => ({
    type: types.SAVE_SETTINGS_FAILED,
    payload: { error },
  }),

  saveSettingsCanceled: () => ({ type: types.SAVE_SETTINGS_CANCELED }),
}
